import wadiDeglaAxios from './WadiDeglaAxios';
import Firebase from './Firebase';

class Connections {
  static wadiDeglaAxios = wadiDeglaAxios;
  static firebase = Firebase;
}

export default Connections;
